import { makeStyles } from '@material-ui/core/styles';
import Theme from '../../../../utils/theme';

const useStyles = makeStyles({
  flightWrapper: {
    paddingTop: '0 !important',
  },
  FlightSummary: {
    backgroundColor: Theme.palette.white,
    display: 'flex',
    borderRadius: 5,
    boxShadow: 'none',
  },
  cardWrapper: {
    flex: '1',
    '& .divider': {
      '&:last-child': {
        display: 'none',
      },
    },
  },
  departure: {
    '& div:nth-child(8)': {
      textTransform: 'capitalize',
      '& span': {
        textTransform: 'capitalize',
      },
    },
    '& div:nth-child(9)': {
      borderStyle: 'none',
    },
    '& div:nth-child(3)': {
      '& p': {
        marginBottom: 0,
      },
    },

    [Theme.breakpoints.up('xl')]: {
      padding: '0',
      margin: '30px',
      borderBottom: `1px solid ${Theme.palette.border}`,
      paddingBottom: '30px',
      marginBottom: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      padding: '15px 20px 15px 20px',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '20px 20px 20px 20px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '20px 30px 20px 30px !important',
      '& div:nth-child(3)': {
        marginRight: '3px !important',
      },
      '& div:nth-child(8)': {
        display: 'flex',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      '& img': {
        padding: 0,
        marginTop: 3,
      },
      '& div:nth-child(7)': {
        gridRow: '5',
      },
    },
  },
});

export default useStyles;
